export enum ShieldingLevel {
  LavelA = 1,
  LavelB = 2,
  LavelBPlus = 3,
  LavelC = 4,
  LavelCPlus = 5,
  LavelD = 6,
  LavelE = 7,
  DoesNotApply = 9,
}

export const shieldingLevelValues: { [id: number]: string } = {
  1: 'Nivel A',
  2: 'Nivel B',
  3: 'Nivel B Plus',
  4: 'Nivel C',
  5: 'Nivel C Plus',
  6: 'Nivel D',
  7: 'Nivel E',
  9: 'No Aplica',
};

export namespace ShieldingLevel {
  export function items() {
    var items = Object.keys(ShieldingLevel)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        let value = index;

        return { key: shieldingLevelValues[+value + 1], value: +value + 1 };
      });

    items = items.filter((x) => x.key != undefined);
    items = array_move(items, 7, 0);
    return items;
  }

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  }
}
